import React from 'react'
import Answers from './answers/Answers'
import { Flex } from 'antd'

const AllQuestionsContent = ({ submissionId }) => {
    return (
        <Flex vertical gap={8}>
            <Answers submissionId={submissionId} />
        </Flex>
    )
}

export default AllQuestionsContent
